import { useCallback, useMemo, useState } from 'react';
import useCurrentUser from 'src/hooks/useCurrentUser';
import buildNavItems from 'src/layouts/PropertyGroupLayout/lib/buildNavItems/buildNavItems';
import { matchPath, useLocation } from 'react-router';
import { useQuery } from '@apollo/client';
import { PropertyGroupPageDocument } from 'src/graphql/queries/PropertyGroupPage';

export function usePropertyGroupLayoutData() {
  const [navOpen, setNavOpen] = useState(false);
  const user = useCurrentUser();

  const { pathname } = useLocation();
  const match = matchPath(
    { path: '/property-groups/:propertyGroupId/*' },
    pathname,
  );

  const propertyGroupId = match?.params.propertyGroupId;

  const { data, loading } = useQuery(PropertyGroupPageDocument, {
    skip: !propertyGroupId,
    variables: {
      propertyGroupId: propertyGroupId ?? '',
      offset: 0,
      limit: 5,
    },
  });

  const propertyGroup = data?.propertyGroup;

  const navItems = useMemo(
    () => buildNavItems(propertyGroupId ?? ''),
    [propertyGroupId],
  );

  const handleToggleNav = useCallback(() => {
    setNavOpen(!navOpen);
  }, [setNavOpen, navOpen]);

  return {
    handleToggleNav,
    loading,
    navItems,
    navOpen,
    propertyGroupId,
    user,
    propertyGroup,
  };
}
